import styled from "styled-components";
import { Table } from "../../../../styles/table";

export const AdminClientsTableContainer = styled(Table)`
  th,
  td {
    &:last-child {
      text-align: center;
    }
  }

  tr {
    cursor: pointer;
  }
`;
